import type { GetAllRequestParameters } from '@pct-ng/core/dto';
import { AbstractDtoService } from '@pct-ng/core/dto';
import {
  type AuditorAllListDTO,
  type AuditorGetDTO,
  type AuditorListDTO,
  type AuditorPostPutDTO,
  AuditorService,
} from '@szebit-app/sdk/backend';
import { Injectable } from '@angular/core';
import type { HttpContext } from '@angular/common/http';
import type { ListPaginatedDTO } from '@pct-sdk/core';
import { map, type Observable } from 'rxjs';
import { isNil } from '@pct-ts/typeguard';

@Injectable()
export class AuditorDtoService extends AbstractDtoService<
  AuditorService,
  AuditorPostPutDTO,
  AuditorGetDTO,
  AuditorListDTO,
  'id'
> {
  constructor() {
    super({ sort: 'name', direction: 'ASC' }, AuditorService);
  }

  override create(dto: AuditorPostPutDTO, httpContext?: HttpContext): Observable<AuditorGetDTO> {
    // TODO backendnek szolni adja vissza
    return this.service
      .createAuditor(dto, httpContext)
      .pipe(map(() => dto as unknown as AuditorGetDTO));
  }

  override update(
    id: string,
    dto: AuditorPostPutDTO,
    httpContext?: HttpContext,
  ): Observable<AuditorGetDTO> {
    // TODO backendnek szolni adja vissza
    return this.service.updateAuditor(id, dto, httpContext);
  }

  override delete(id: string, httpContext?: HttpContext): Observable<void> {
    return this.service.deleteAuditor(id, httpContext);
  }

  override getById(id: string, httpContext?: HttpContext): Observable<AuditorGetDTO> {
    return this.service.findAuditor(id, httpContext);
  }

  override getAll(
    { pagination, sort }: GetAllRequestParameters<any>,
    httpContext?: HttpContext,
  ): Observable<ListPaginatedDTO<AuditorListDTO, any>> {
    return this.service.listAuditors(
      sort?.field,
      // eslint-disable-next-line sonarjs/no-nested-conditional
      sort?.order === undefined ? undefined : sort?.order === 'asc' ? 'Asc' : 'Desc',
      pagination?.size,
      pagination?.page,
      httpContext,
    );
  }

  override getDtoId(dto: AuditorGetDTO): string;
  override getDtoId(dto: AuditorGetDTO | null | undefined): string | null | undefined;
  override getDtoId(dto: Partial<AuditorGetDTO> | null | undefined): string | null | undefined;
  override getDtoId(
    dto: AuditorGetDTO | Partial<AuditorGetDTO> | null | undefined,
  ): string | null | undefined {
    if (isNil(dto)) {
      return dto;
    }
    return dto.id;
  }

  override toString(dto: AuditorGetDTO): string {
    return dto.name ?? 'UNKNOWN ITEM';
  }

  listAll(): Observable<AuditorAllListDTO[]> {
    return this.service.listAllAuditors();
  }
}
